import { toast } from "react-hot-toast";

export const downloadFile = (fileUrl, fileName) => {
  if (!fileUrl) {
    toast.error("Файл URL табылмады");
    return;
  }

  const link = document.createElement("a");
  link.href = fileUrl;
  link.download = fileName || "";
  // Browsers ignore the download attribute on cross-origin URLs (e.g. S3) —
  // without a target the click would navigate the SPA away to the raw file.
  link.target = "_blank";
  link.rel = "noopener";
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  toast.success("Файл жүктеу басталды!");
};

export const getFileExtension = (filename) => {
  return filename?.split(".").pop()?.toLowerCase() || "";
};

export const getFileTypeIcon = (filename) => {
  const extension = getFileExtension(filename);

  switch (extension) {
    case "pdf":
      return "📄";
    case "doc":
    case "docx":
      return "📝";
    case "xls":
    case "xlsx":
      return "📊";
    case "ppt":
    case "pptx":
      return "📋";
    case "jpg":
    case "jpeg":
    case "png":
    case "gif":
      return "🖼️";
    default:
      return "📁";
  }
};
